<template>
  <transition name="fade" mode="in-out">
    <img
      :key="currentImage"
      :src="require(`../assets/${currentImageSrc}`)"
      style="position:absolute;left:0;top:0"
    />
  </transition>
</template>

<script>
export default {
  name: "ImageCarousel",
  props: {
    displayTime: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentImage: 0,
      images: ["iStock-1061013482.jpg", "iStock-1131158829.jpg"]
    };
  },
  computed: {
    currentImageSrc() {
      return this.images[this.currentImage];
    }
  },
  mounted() {
    setTimeout(this.cycleImages, this.displayTime * 1000);
  },
  methods: {
    cycleImages() {
      this.currentImage = (this.currentImage + 1) % this.images.length;
      setTimeout(this.cycleImages, this.displayTime * 1000);
    }
  }
};
</script>

<style scoped lang="less">
.fade-enter-active,
.component-fade-leave-active {
  transition: opacity 5s ease;
}
.fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
